import { createFileRoute } from '@tanstack/react-router'
import InventairesTab from '@features/stock/components/InventairesTab'

export const Route = createFileRoute('/_app/stock/inventaires/')({
  component: InventairesTab,
})
